import clsx from 'clsx'
import React from 'react'
import ActiveToggle from './active-toggle'
import ResetBaseline from './reset-baseline'

const NodeListItem = ({ node, mutate }) => {
  const statusStyle = () => {
    if (node.node?.status?.connectivityState === 'connected') {
      return 'bg-green-400'
    }
    if (node.node?.status?.connectivityState === 'disconnected') {
      return 'bg-red-400'
    }
    return 'bg-gray-100'
  }

  return (
    <div className="flex items-center space-x-2">
      <div className={clsx('w-4 h-4 rounded-full', statusStyle())}></div>

      <a
        href={node.url}
        target="_blank"
        className="hover:underline cursor-pointer"
      >
        {node.name} [{node.node?.environment?.toUpperCase()}]
      </a>
      {node.operational_state && (
        <ActiveToggle
          nodeStatus={node.node?.status}
          nodeId={node.node?.id}
          mutate={mutate}
        />
      )}
      {node.baseline && (
        <div className="!ml-auto">
          <ResetBaseline nodeId={node.node?.id} mutate={mutate} />
        </div>
      )}
    </div>
  )
}

export default NodeListItem
